import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Send } from "lucide-react";
import api from "@/lib/api";

// Fixed (non-flying) Telegram group link pinned to the bottom-right corner.
export default function FloatingTelegram() {
  const [url, setUrl] = useState("https://t.me/DEMONCLUB92");

  useEffect(() => {
    api
      .get("/settings")
      .then(({ data }) => {
        if (data.telegram_group) setUrl(data.telegram_group);
      })
      .catch(() => {});
  }, []);

  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="floating-telegram"
      className="fixed bottom-5 right-5 z-[80] select-none"
    >
      <motion.div
        animate={{
          boxShadow: [
            "0 0 16px rgba(56,189,248,0.45)",
            "0 0 30px rgba(56,189,248,0.85)",
            "0 0 16px rgba(56,189,248,0.45)",
          ],
        }}
        transition={{ duration: 2.4, repeat: Infinity, ease: "easeInOut" }}
        whileHover={{ scale: 1.05 }}
        className="flex items-center gap-2 pl-3 pr-4 h-11 rounded-full bg-gradient-to-r from-sky-500 to-cyan-400 text-white font-display font-semibold border border-sky-200/40"
      >
        <Send size={18} />
        <span className="hidden sm:inline text-sm whitespace-nowrap font-mono font-bold">
          {url.replace(/^https?:\/\//, "")}
        </span>
      </motion.div>
    </a>
  );
}
